import {
    Row,
    Col,
    Card,
    Radio,
    Table,
    notification,
    Button,
    Input,
    Menu,
    Dropdown,
    Modal
} from "antd";

import { SearchOutlined, DownOutlined, ExclamationCircleOutlined } from "@ant-design/icons";


// Images
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBookingsTour, getBookingById, deleteTourBookings } from "../api/booking.service";
import moment from "moment";
import EditTourBookingPackageModal from "../components/forms/tour-booking/EditTourBookingPackageModal";

// project table start


function TourBookings() {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
    const [vehicleData, setVehicleData] = useState(null);
    const [isViewOnly, setisViewOnly] = useState(false);


    const getColumnSearchProps = (dataIndex, placeholder) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${placeholder}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => confirm()}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    onClick={() => confirm()}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
            const recordValue =
                dataIndex === "selectedPackage"
                    ? record[dataIndex]?.name
                    : record[dataIndex];
            return recordValue
                ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
                : false;
        },
    });


    const project = [
        {
            title: "REFERENCE NO",
            dataIndex: "referenceNo",
            width: 100,
            ...getColumnSearchProps("referenceNo", "Reference No"),
            render: (text, record) => <div>{record.referenceNo}</div>,
        },
        // {
        //     title: "NAME",
        //     dataIndex: "name",
        //     width: 100,
        //     ...getColumnSearchProps("name", "Name"),
        // },
        // {
        //     title: "PHONE",
        //     dataIndex: "phone",
        //     width: 100,
        //     ...getColumnSearchProps("phone", "Phone"),
        // },
        {
            title: "CUSTOMER EMAIL",
            dataIndex: "email",
            width: 100,
            ...getColumnSearchProps("email", "Email"),
        },
        {
            title: "PACKAGE",
            dataIndex: "selectedPackage",
            width: 100,
            ...getColumnSearchProps("selectedPackage", "Package"),
            render: (text, record) => (
                <div>
                    <Link to={`/tours/${record.selectedPackage.id}`}>
                        <div
                            style={{
                                textDecoration: "underline",
                                color: "blue",
                                cursor: "pointer",
                            }}
                        >
                            {record.selectedPackage.name}
                        </div>
                    </Link>
                </div>
            ),
        },
        {
            title: "SUPPLIER EMAIL",
            dataIndex: "supplierEmail",
            width: 100,
            ...getColumnSearchProps("supplierEmail", "Supplier"),
            render: (text, record) => (
                <div>
                    {record.selectedPackage.supplierEmail}
                </div>
            ),
        },
        {
            title: "ACTIONS",
            width: 100,
            render: (text, record) => {
                const menu = (
                    <Menu>
                        <Menu.Item
                            key="view"
                            onClick={() => getVehicleData(record.referenceNo, true)}
                        >
                            View
                        </Menu.Item>
                        <Menu.Item
                            key="edit"
                            onClick={() => getVehicleData(record.referenceNo, false)}
                        >
                            Edit
                        </Menu.Item>
                    </Menu>
                );
                return (
                    <Dropdown overlay={menu}>
                        <a
                            className="ant-dropdown-link"
                            onClick={(e) => e.preventDefault()}
                        >
                            Tasks <DownOutlined />
                        </a>
                    </Dropdown>
                );
            },
        },
    ];

    const fetchBookings = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await getBookingsTour();
            setBookings(data?.data || []);
            // notification.success({ message: 'Data refreshed' })
        } catch (err) {
            setError('Failed to fetch bookings.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBookings();
    }, []);

    useEffect(() => {
        const ws = new WebSocket(process.env.REACT_APP_API_URL.replace('https://', 'wss://').replace('http://', 'ws://')); 

        ws.onopen = () => {
            console.log("Connected to WebSocket server");
        };

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.event === "tour-booking-added") {
                fetchBookings();
            }
        };

        ws.onclose = () => {
            console.log("Disconnected from WebSocket server");
        };

        // Cleanup WebSocket connection on unmount
        return () => {
            ws.close();
        };
    }, []);

    const onChange = (e) => console.log(`radio checked:${e.target.value}`);

    const getVehicleData = async (id, isViewOnly = false) => {
        setisViewOnly(isViewOnly)
        const data = await getBookingById(id);
        setVehicleData(data.data);
        setIsModalOpenEdit(true);
    }

    useEffect(() => {
        fetchBookings();
    }, []);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleOkEdit = () => {
        setIsModalOpenEdit(false);
    };

    const handleCancelEdit = () => {
        setIsModalOpenEdit(false);
    };

    const handleBulkDelete = async () => {
        if (selectedRowKeys.length === 0) {
            notification.warning({
                message: 'Please select at least one booking to delete'
            });
            return;
        }

        Modal.confirm({
            title: (
                <span style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '18px' }}>
                    <ExclamationCircleOutlined style={{ marginRight: 8 }} />
                    Warning - Permanent Deletion
                </span>
            ),
            icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
            content: (
                <div style={{ fontSize: '16px', marginTop: 10 }}>
                    <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
                        Are you sure you want to permanently delete <strong style={{ color: '#ff4d4f' }}>{selectedRowKeys.length}</strong> tour booking(s)?
                    </p>
                    <p style={{ color: '#ff4d4f', marginTop: 10 }}>
                        ⚠️ This action cannot be undone. All selected bookings will be permanently removed from the database.
                    </p>
                </div>
            ),
            okText: "Yes, Delete Permanently",
            okType: "danger",
            cancelText: "Cancel",
            width: 500,
            onOk: async () => {
                try {
                    setLoading(true);
                    // Convert referenceNos to IDs
                    const ids = selectedRowKeys.map(refNo => {
                        const booking = bookings.find(b => b.referenceNo === refNo);
                        return booking?.id;
                    }).filter(id => id !== undefined);
                    
                    const response = await deleteTourBookings(ids);
                    notification.success({
                        message: response.msg || `Successfully deleted ${response.data?.deletedCount || ids.length} tour booking(s)`
                    });
                    setSelectedRowKeys([]);
                    fetchBookings();
                } catch (error) {
                    notification.error({
                        message: error?.response?.data?.msg || error?.response?.data?.message || 'Failed to delete tour bookings'
                    });
                } finally {
                    setLoading(false);
                }
            },
            onCancel() {
                console.log("Bulk delete cancelled");
            },
        });
    }

    return (
        <>
            {vehicleData && <EditTourBookingPackageModal isViewOnly={isViewOnly} vehicleData={vehicleData} fetchVehicles={fetchBookings} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Tour Bookings Table"
                            extra={
                                selectedRowKeys.length > 0 && (
                                    <Button
                                        type="primary"
                                        danger
                                        onClick={handleBulkDelete}
                                        loading={loading}
                                    >
                                        Delete Selected ({selectedRowKeys.length})
                                    </Button>
                                )
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    rowSelection={{
                                        type: 'checkbox',
                                        selectedRowKeys,
                                        onChange: setSelectedRowKeys,
                                    }}
                                    rowKey="referenceNo"
                                    columns={project}
                                    dataSource={bookings}
                                    pagination={{
                                        pageSize: 100
                                    }}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default TourBookings;
